import { render, staticRenderFns } from "./FullCalendarCore.vue?vue&type=template&id=1177ff98&"
import script from "./FullCalendarCore.vue?vue&type=script&lang=js&"
export * from "./FullCalendarCore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports